import { useContext } from "react";
import { LangContext } from "../../Context/Langcontext";

const DataServiceList = () => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return {
    vector: [{ title: lang.LandmarkPoint }],
    raster: [],
  };
};

export default DataServiceList;
